import React from "react";
import { Box, TextField, Button } from "@mui/material";

import classes from "../login/login.module.css";
import { Link } from "react-router-dom";
import UrbcLogo from "../../../components/urbc-logo/urbc-logo";

const ForgotPassword = () => {
   return (
      <Box className={classes.login}>
         <Box className={classes.loginForm}>
            <form>
               <Box className={classes.Form}>
                  <Box>
                     <UrbcLogo />
                  </Box>
               </Box>
               <Box className={classes.Email}>
                  <TextField
                     type="email"
                     sx={{ background: "white" }}
                     variant="outlined"
                     label="Email"
                     fullWidth
                     placeholder="Kindly enter your Email"
                  />
               </Box>

               <Box className={classes.Button}>
                  <Button
                     sx={{ background: "#001A72" }}
                     className={classes.loginButton}
                     type="submit"
                     variant="contained"
                  >
                     Login
                  </Button>
                  <p>
                     Back to <Link to="/login">Login</Link>
                  </p>
               </Box>
            </form>
         </Box>
      </Box>
   );
};

export default ForgotPassword;
